(function () {
  'use strict';

  class StateUrlService {
    constructor($location, $window, $rootScope, Authenticator, $state, InformativoKeys, GoogleTagManagerUtils) {
      this.location = $location;
      this.window = $window;
      this.rootScope = $rootScope;
      this.authenticator = Authenticator;
      this.state = $state;
      this.informativoKeys = InformativoKeys;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
    }

    initInterceptBloqueioSolucao() {
      this.rootScope.$on('$stateChangeStart', this.interceptBloqueioSolucao.bind(this));
    }

    onPageLoad() {
      this.authenticator.getUser().then(user => {
        const urlState = this.location.url();
        if (!this.state.previous || this.state.current.name !== this.state.previous.name) {
          this.googleTagManagerUtils.sendEventClickGTM('page_view', user, {page: urlState});
        }
      });
    }

    interceptBloqueioSolucao(event, toState) {
      const informativoState = this.informativoKeys[toState.name];

      this.authenticator.getUser().then((user) => {
        if (informativoState && toState.data && toState.data.role && !this.checkPermissaoSolucaoUsuario(user, toState.data.role)) {
          event.preventDefault();
          this.state.go('root.informativo', {
            informativoKey: informativoState[0].key,
            uoId: this.rootScope.usuario.uo.id
          });
        }
      });
    }

    checkPermissaoSolucaoUsuario(user, stateAllowedRoles) {
      const usuarioRolesSolucao = user.permissoesSolucao;
      if (angular.isString(stateAllowedRoles)) {
        return usuarioRolesSolucao.indexOf(stateAllowedRoles) !== -1;
      }
      if (angular.isArray(stateAllowedRoles)) {
        return stateAllowedRoles.some(allowedRole => {
          return this.checkPermissaoRole(allowedRole, usuarioRolesSolucao);
        });
      }

      return false;
    }

    checkPermissaoRole(role, permissoes) {
      if (angular.isString(role)) {
        return permissoes.indexOf(role) !== -1;
      }
      // must have all roles of this when it's an array
      return role.filter(roleVal => this.checkPermissaoRole(roleVal, permissoes)).length === role.length;
    }
  }

  const INTELLIGENCE = 135, INTELLIGENCE_VIDEO = 150, VFLEETS = 136;
  angular
    .module('stateUrlModule', [
      'ui.router',
      'v3gAuthenticatorModule',
      'enumModule',
      'SolucoesModule',
      'ConstantModule'
    ])
    .constant('InformativoKeys', {
      'root.camadaValor': {solucoesId: [VFLEETS, INTELLIGENCE, INTELLIGENCE_VIDEO], redirectTo: 'root.informativoCamadaValor'}
    })
    .service('StateUrlService', StateUrlService);
}());
